import * as React from 'react'
import {importReg} from '../../dispatchers/appConstrImportDispatcher'
import {connect} from 'react-redux'
import {IAppStore} from '../../interfaces/reducers'
import {IConstrImportActionData, IConstrConnectValidationData} from '../../interfaces/reducers/IConstrImport'

interface OwnProps {
  importActionData: IConstrImportActionData
  connectValidationData: IConstrConnectValidationData
}

interface ParentProps {}

interface DispatchProps {
  importReg: typeof importReg
}

type Props = DispatchProps & ParentProps & OwnProps

const RegImportActionClass = (props: Props) => {
  const getSuccessData = () => {
    return (
      <div className="import-params-success">
        <div>Успешен импорт</div>
      </div>
    )
  }
  const getValidationStatusUI = () => {
    if (props.importActionData.loading) {
      if (props.importActionData.success) {
        return getSuccessData()
      }
      return <div className="import-loading">В процес на импорт...</div>
    } else {
      if (props.importActionData.errors && props.importActionData.errors.length > 0) {
        const errors: JSX.Element[] = []
        props.importActionData.errors.forEach((e, i) => {
          errors.push(<div key={i}>{e}</div>)
        })
        return (
          <div className="import-params-errors">
            <div>Грешки при импорт:</div>
            {errors}
          </div>
        )
      } else if (props.importActionData.success) {
        return getSuccessData()
      }
    }
  }
  if (!props.connectValidationData.successData) {
    return <div></div>
  }
  return (
    <div style={{padding: '10px', boxSizing: 'border-box'} as React.CSSProperties}>
      {getValidationStatusUI()}
      {props.importActionData.success || props.importActionData.loading ? null : (
        <button
          type="button"
          className="button width"
          onClick={() => {
            props.importReg(props.connectValidationData.successData!.importPath)
          }}
        >
          ИМПОРТ
        </button>
      )}
    </div>
  )
}

const mapStoreToProps = (store: IAppStore) => ({
  importActionData: store.constrImport.importActionData,
  connectValidationData: store.constrImport.connectValidationData
})

export const ConstrImportAction = connect<OwnProps, DispatchProps, ParentProps>(mapStoreToProps, {importReg})(
  RegImportActionClass
)
